import { render, staticRenderFns } from "./DesignContent2.vue?vue&type=template&id=e1f6ffdc&"
import script from "./DesignContent2.vue?vue&type=script&lang=ts&"
export * from "./DesignContent2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports